import { HttpClient, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, LOCALE_ID, enableProdMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { ENCRYPT_STORAGE_KEY, encryptStorageProvider } from '@global-front-components/common/encrypt-storage';
import { CaserTranslateHttpLoader } from '@global-front-components/common/traslate-loader';
import { CaLoaderInterceptorProvider } from '@global-front-components/ui/loader-interceptor';
import { cafBootHttpErrorInterceptor } from './app/comun/interceptor/caf-boot-http-error.interceptor';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HIGHLIGHT_OPTIONS, HighlightModule, HighlightOptions } from 'ngx-highlightjs';
import { MarkdownModule } from 'ngx-markdown';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { AppComponent } from './app/app.component';
import { appRoutes } from './app/app.routes';
import { environment } from './environments/environment';
import { provideStoreConfigOnEnvironment } from '@global-front-components/common/environment-utils';

import '@angular/common/locales/global/en';
import '@angular/common/locales/global/es';
import { ConfigService } from './app/comun/services/util/config.service';

if (environment.production) {
	enableProdMode();
}

// Se crea este inicializador para forzar la carga de la configuración antes de que se cargue la aplicación.
// Esto se hace forzando la inicialización de ConfigService.
// Probablemente haya una solución más elegante, pero no la he encontrado.
export function initializeApp(): () => Promise<void> {
	return () => null;
}

bootstrapApplication(AppComponent, {
	providers: [
		provideRouter(appRoutes),
		importProvidersFrom(
			MarkdownModule.forRoot(),
			HighlightModule,
			TranslateModule.forRoot({
				defaultLanguage: 'es',
				loader: {
					provide: TranslateLoader,
					useClass: CaserTranslateHttpLoader,
					deps: [HttpClient]
				},
				isolate: false
			})
		),
		{
			provide: HIGHLIGHT_OPTIONS,
			useValue: <HighlightOptions>{
				lineNumbers: true,
				coreLibraryLoader: () => import('highlight.js/lib/core'),
				languages: {
					typescript: () => import('highlight.js/lib/languages/typescript'),
					css: () => import('highlight.js/lib/languages/css'),
					xml: () => import('highlight.js/lib/languages/xml')
				}
			}
		},
		CaLoaderInterceptorProvider(),
		provideEnvironmentNgxMask(),
		encryptStorageProvider(),
		{
			provide: ENCRYPT_STORAGE_KEY,
			useValue: 'TEST_ENCRYPT_KEY'
		},
		provideStoreConfigOnEnvironment(environment),
		provideAnimations(),
		provideHttpClient(
			withInterceptorsFromDi(),
			withInterceptors([cafBootHttpErrorInterceptor]),

		),
		{ provide: LOCALE_ID, useValue: 'es' },
		ConfigService,
		{
			provide: APP_INITIALIZER,
			useFactory: initializeApp,
			deps: [ConfigService],
			multi: true
		}
	]
}).catch((err) => console.error(err));
